import { ContractConceptState } from '../../states/ContractConceptState';
import { Action } from 'redux';
import * as CommonFunctions from '../Common/Functions';
import ContractConceptCreateReducer from './Contract.Concept.Create.Reducer';
import ContractConceptUpdateReducer from './Contract.Concept.Update.Reducer';
import ContractConceptDeleteReducer from './Contract.Concept.Delete.Reducer';


export const CombinedContractConceptReducer = CommonFunctions.reduceReducers<ContractConceptState>(
    ContractConceptCreateReducer,
    ContractConceptUpdateReducer,
    ContractConceptDeleteReducer
);
